import { TourProductModel } from 'api-hooks/tour/tour-list/tour-detail';
import classNames from 'classnames';
import { useFormState } from 'components/elements/form';
import { SeparatorVertical } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';

import ProductTable from './product-table';
import styles from '../styles.module.css';

interface Props {
  products?: TourProductModel[];
}

export function ProductTab(props: Props) {
  const { editable } = useFormState();
  const { t } = useTranslation();
  return (
    <div className={classNames(styles.padtb16, styles.fullFlex)}>
      {(!editable && !!props.products?.length) || editable ? (
        <ProductTable />
      ) : (
        <>{t('common:no_product_set_yet')}</>
      )}

      <SeparatorVertical $margin={24} />
    </div>
  );
}
